import { render, staticRenderFns } from "./OrderUserOverrides.vue?vue&type=template&id=5b63b883&scoped=true&"
import script from "./OrderUserOverrides.vue?vue&type=script&lang=js&"
export * from "./OrderUserOverrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63b883",
  null
  
)

export default component.exports